export default "__VITE_ASSET__BIlNWgTX__"